import { render, staticRenderFns } from "./opcionesCS.vue?vue&type=template&id=2bd7a2d1&"
import script from "./opcionesCS.vue?vue&type=script&lang=ts&"
export * from "./opcionesCS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2bd7a2d1', component.options)
    } else {
      api.reload('2bd7a2d1', component.options)
    }
    module.hot.accept("./opcionesCS.vue?vue&type=template&id=2bd7a2d1&", function () {
      api.rerender('2bd7a2d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/CambiosServicio/opcionesCS.vue"
export default component.exports